import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import { login as _login, logout as _logout, getInfo as _getInfo, unlock as _unlock } from '@/api/user';
import { setLock as _setLock, getLock, removeLock, getToken, setToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';
import qs from 'qs';
import md5 from 'js-md5';
var define = require('@/utils/define');
var state = {
  token: getToken(),
  isLock: getLock() || 0,
  menuList: [],
  leftMenuList: [],
  userInfo: {},
  permissionList: [],
  loginLoading: false,
  socket: ''
};
var mutations = {
  SET_SOCKET: function SET_SOCKET(state, socket) {
    state.socket = socket;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_MENULIST: function SET_MENULIST(state, menuList) {
    state.menuList = menuList;
  },
  SET_LEFTMENULIST: function SET_LEFTMENULIST(state, leftMenuList) {
    state.leftMenuList = leftMenuList;
  },
  SET_USERINFO: function SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_USERINFO_HEADICON: function SET_USERINFO_HEADICON(state, headIcon) {
    state.userInfo.headIcon = headIcon;
  },
  SET_USERINFO_USERNAME: function SET_USERINFO_USERNAME(state, userName) {
    state.userInfo.userName = userName;
  },
  SET_USERINFO_PORTALID: function SET_USERINFO_PORTALID(state, portalId) {
    state.userInfo.portalId = portalId;
  },
  SET_PERMISSION_LIST: function SET_PERMISSION_LIST(state, permissionList) {
    state.permissionList = permissionList;
  },
  SET_LOCK: function SET_LOCK(state, isLock) {
    state.isLock = isLock;
  },
  SET_LOGIN_LOADING: function SET_LOGIN_LOADING(state, loginLoading) {
    state.loginLoading = loginLoading;
  }
};
var actions = {
  // 锁屏
  setLock: function setLock(_ref) {
    var commit = _ref.commit;
    commit('SET_LOCK', 1);
    _setLock(1);
  },
  clearLock: function clearLock(_ref2) {
    var commit = _ref2.commit;
    commit('SET_LOCK', '');
    removeLock();
  },
  unlock: function unlock(_ref3, userInfo) {
    var dispatch = _ref3.dispatch;
    var account = userInfo.account,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      _unlock({
        account: account.trim(),
        password: md5(password)
      }).then(function (response) {
        dispatch('clearLock');
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user login
  login: function login(_ref4, userInfo) {
    var commit = _ref4.commit;
    var account = userInfo.account,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      _login(qs.stringify({
        account: account.trim(),
        password: md5(password),
        client_id: 'admin',
        client_secret: '123456',
        scope: 'all',
        grant_type: 'password'
      })).then(function (response) {
        var data = response.data;
        var layoutList = ['classic', 'functional', 'plain', 'blend'];
        var layoutType = data.theme && layoutList.indexOf(data.theme) > -1 ? data.theme : 'classic';
        commit('SET_TOKEN', data.token);
        commit('settings/CHANGE_SETTING', {
          key: "layoutType",
          value: layoutType
        }, {
          root: true
        });
        setToken(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取用户信息
  getInfo: function getInfo(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      _getInfo().then(function (response) {
        var data = response.data;
        if (!data) reject('验证失败，请重新登录。');
        var menuList = data.menuList,
          userInfo = data.userInfo,
          permissionList = data.permissionList;
        if (!menuList.length) {
          reject('您的权限不足，请联系管理员');
          return false;
        }
        var routerList = [];
        function setData(list) {
          var _loop = function _loop() {
            var e = list[i];
            var name = e.enCode.replace(/\./g, '-');
            e.vueName = name;
            if (e.type == 1) {
              e.path = '/' + e.enCode;
              if (e.hasChildren && e.children.length) {
                setData(e.children);
              }
            }
            if (e.type == 2) {
              var path = e.urlAddress;
              if (path.indexOf("?") > -1) path = path.split("?")[0];
              e.path = '/' + e.urlAddress;
              var newObj = {
                path: '/' + path,
                component: function component(resolve) {
                  return require(["@/views/".concat(path)], resolve);
                },
                name: name,
                meta: {
                  title: name,
                  icon: e.icon,
                  zhTitle: e.fullName,
                  modelId: e.id
                }
              };
              routerList.push(newObj);
            }
            // 功能、字典、报表、门户
            if ([3, 4, 5, 8].indexOf(e.type) > -1) {
              var propertyJson = e.propertyJson ? JSON.parse(e.propertyJson) : null,
                relationId = '',
                isTree = 0,
                componentUrl = '';
              if (propertyJson) {
                relationId = propertyJson.moduleId || '';
                isTree = propertyJson.isTree || 0;
              }
              if (e.type == 3) {
                componentUrl = 'dynamicModel';
              } else if (e.type == 4) {
                componentUrl = 'dynamicDictionary';
              } else if (e.type == 5) {
                componentUrl = 'dynamicDataReport';
              } else {
                componentUrl = 'dynamicPortal';
              }
              e.path = '/' + e.urlAddress;
              var _newObj = {
                path: '/' + e.urlAddress,
                component: function component(resolve) {
                  return require(["@/views/basic/".concat(componentUrl)], resolve);
                },
                name: e.enCode,
                meta: {
                  title: name,
                  icon: e.icon,
                  zhTitle: e.fullName,
                  modelId: e.id,
                  relationId: relationId,
                  isTree: isTree
                }
              };
              routerList.push(_newObj);
            }
            // 大屏
            if (e.type == 6) {
              var _propertyJson = e.propertyJson ? JSON.parse(e.propertyJson) : null,
                moduleId = '';
              if (_propertyJson) moduleId = _propertyJson.moduleId || '';
              e.path = "".concat(define.dataV, "/view/").concat(moduleId, "?token=").concat(getToken());
            }
            // 外链
            if (e.type == 7) {
              if (e.linkTarget === "_self") {
                e.path = '/' + e.enCode;
                var _newObj2 = {
                  path: '/' + e.enCode,
                  component: function component(resolve) {
                    return require(["@/views/basic/externalLink"], resolve);
                  },
                  name: e.enCode,
                  meta: {
                    title: name,
                    icon: e.icon,
                    zhTitle: e.fullName,
                    modelId: e.id,
                    urlAddress: e.urlAddress
                  }
                };
                routerList.push(_newObj2);
              } else {
                var _path = e.urlAddress.replace(/\${dataV}/g, define.dataV).replace(/\${weforsysToken}/g, getToken());
                e.path = _path;
              }
            }
          };
          for (var i = 0; i < list.length; i++) {
            _loop();
          }
        }
        setData(menuList);
        commit('SET_MENULIST', menuList);
        commit('SET_USERINFO', userInfo);
        commit('SET_PERMISSION_LIST', permissionList);
        resolve(routerList);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_MENULIST', []);
        commit('SET_USERINFO', {});
        commit('SET_PERMISSION_LIST', []);
        removeToken();
        resetRouter();

        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_MENULIST', []);
      commit('SET_USERINFO', {});
      commit('SET_PERMISSION_LIST', []);
      commit('SET_LOGIN_LOADING', false);
      removeToken();
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};